import React, { useState } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  TextField,
  Button,
  Typography,
  Paper,
  Box,
  Alert,
  ToggleButton,
  ToggleButtonGroup,
  Stack,
  CircularProgress,
} from '@mui/material';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { POS_API_BASE_URL } from '../utils/apiHelper';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedLoginType, setSelectedLoginType] = useState('pos');
  const navigate = useNavigate();
  const { setLoginType, setPosToken } = useAuth();

  const handleLoginTypeChange = (event, newLoginType) => {
    if (newLoginType !== null) {
      setSelectedLoginType(newLoginType);
      setError('');
      setPassword('');
      setPin('');
    }
  };

  const handleGutsLogin = async () => {
    try {
      setLoginType('guts');
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/search');
    } catch (err) {
      throw new Error(err.message);
    }
  };

    const handlePosLogin = async () => {
    try {
      setLoginType('pos');
      
      const response = await axios.post(
        `${POS_API_BASE_URL}/admin/storeLogin?hash=c43ca1622ab90bc90b762a516426c5f18a6c169c871a7f6adb30c3b570e622c0`,
        {
          email: email,
          pin: pin,
          pos_region: 'giva_in'
        },
        {
          headers: {
            'accept': 'application/json',
            'content-type': 'application/json',
            'pos_region': 'giva_in',
          }
        }
      );

      // Check for success flag instead of just status
      if (response.data.success === true && response.data.data?.token) {
        setPosToken(response.data.data.token);
        navigate('/search');
      } else {
        // Handle error cases where success is false
        throw new Error(response.data.message || 'POS login failed');
      }
    } catch (err) {
      if (err.response?.data) {
        // API returned an error response
        throw new Error(err.response.data.message || 'POS login failed');
      }
      throw new Error(err.message);
    }
  };
  
  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (selectedLoginType === 'guts') {
        await handleGutsLogin();
      } else {
        await handlePosLogin();
        
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          border: 'none',
          borderRadius: 2,
        }}
      >
        <Typography variant="h5" align="center" fontWeight={600}>
          Login
        </Typography>

        {error && <Alert severity="error">{error}</Alert>}

        <Box component="form" onSubmit={handleLogin}>
          <Stack spacing={2}>
            <Box>
              <Typography variant="subtitle2" gutterBottom sx={{ mb: 1 }}>
                Select Login Type
              </Typography>
              <ToggleButtonGroup
                value={selectedLoginType}
                exclusive
                onChange={handleLoginTypeChange}
                fullWidth
                sx={{ mb: 2 }}
              >
                <ToggleButton value="pos" sx={{ textTransform: 'none' }}>
                  POS
                </ToggleButton>
                <ToggleButton value="guts" sx={{ textTransform: 'none' }}>
                  GUTS
                </ToggleButton>
              </ToggleButtonGroup>
            </Box>

            <TextField
              label="Email"
              type="email"
              fullWidth
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
            />

            {selectedLoginType === 'guts' ? (
              <TextField
                label="Password"
                type="password"
                fullWidth
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
              />
            ) : (
              <TextField
                label="PIN"
                type="password"
                fullWidth
                required
                value={pin}
                onChange={(e) => setPin(e.target.value)}
                inputProps={{ maxLength: 4 }}
                disabled={loading}
              />
            )}

            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 2 }}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                `Login with ${selectedLoginType.toUpperCase()}`
              )}
            </Button>
          </Stack>
        </Box>
      </Paper>
    </Container>
  );
};

export default Login;